import { StepShell } from "./ui";
import VehicleEditor from "./VehicleEditor";
import type { AfiliacionForm, VehiculoForm } from "./types";

interface StepVehiculosProps {
  form: AfiliacionForm;
  addVehiculo: () => void;
  removeVehiculo: (id: string) => void;
  updateVehiculo: (id: string, patch: Partial<VehiculoForm>) => void;
  errors: Record<string, string>;
}

export default function StepVehiculos({
  form,
  addVehiculo,
  removeVehiculo,
  updateVehiculo,
  errors,
}: StepVehiculosProps) {
  const isEmpresa = form.tipo === "empresa";

  return (
    <StepShell
      title={isEmpresa ? "Registra tu flota" : "Agrega tus vehículos"}
      description={
        isEmpresa
          ? "Registra cada unidad de tu empresa por separado. No hay límite: agrega tantas como necesites."
          : "Puedes registrar uno o varios vehículos (por ejemplo un camión, dos vans y un autobús). Cada uno con su propio registro."
      }
    >
      <div className="space-y-4">
        {form.vehiculos.map((vehiculo, index) => (
          <VehicleEditor
            key={vehiculo.id}
            vehiculo={vehiculo}
            index={index}
            errors={errors}
            canRemove={form.vehiculos.length > 1}
            onChange={(patch) => updateVehiculo(vehiculo.id, patch)}
            onRemove={() => removeVehiculo(vehiculo.id)}
          />
        ))}

        {errors.vehiculos && (
          <p className="flex items-center gap-1 text-xs text-primary-700">
            <i className="ri-error-warning-line text-sm leading-none" aria-hidden="true"></i>
            {errors.vehiculos}
          </p>
        )}

        <button
          type="button"
          onClick={addVehiculo}
          className="flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg border border-dashed border-primary-300 bg-primary-50/50 px-4 py-4 text-sm font-label font-semibold text-primary-700 transition-colors hover:bg-primary-50"
        >
          <i className="ri-add-line text-lg leading-none" aria-hidden="true"></i>
          Agregar vehículo
        </button>
      </div>
    </StepShell>
  );
}